import { render, staticRenderFns } from "./HomeLogin.vue?vue&type=template&id=3c85b371&scoped=true"
import script from "./HomeLogin.vue?vue&type=script&lang=js"
export * from "./HomeLogin.vue?vue&type=script&lang=js"
import style0 from "./HomeLogin.vue?vue&type=style&index=0&id=3c85b371&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c85b371",
  null
  
)

export default component.exports